import { Platform, StyleSheet } from 'react-native';
import { theme } from '../../theme';
import { signInStyles } from '../../src/signIn/styles/signIn.styles';

const INPUT_BG = '#161C2A';
const BORDER = '#2E3650';
const BORDER_SUBTLE = '#1E2640';
const PURPLE_LIGHT = '#A78BFA';
const PURPLE = '#8B5CF6';

/** Pulls the card up so the monkey sits flush on the card top edge. */
const MONKEY_OVERLAP = 66;

const formStyles = StyleSheet.create({
  monkeyWrapper: {
    alignItems: 'center',
    marginBottom: -MONKEY_OVERLAP,
    zIndex: 2,
    ...(Platform.OS === 'android' && { elevation: 20 }),
  },
  monkeyImage: {
    width: 178,
    height: 162,
    transform: [{ translateY: 10 }],
  },
  brand: {
    fontSize: 24,
    fontWeight: '800',
    color: theme.white,
    textAlign: 'center',
    marginBottom: 8,
    letterSpacing: 0.3,
  },
  brandAccent: {
    color: PURPLE_LIGHT,
  },
  forgotPasswordButton: {
    alignSelf: 'flex-end',
    paddingVertical: 4,
    paddingHorizontal: 2,
    marginBottom: 14,
  },
  forgotPasswordText: {
    color: PURPLE_LIGHT,
    fontSize: 13,
    fontWeight: '500',
  },
  primaryButtonHover: {
    backgroundColor: '#7C3AED',
  },
  toggleButton: {
    marginTop: 18,
    paddingVertical: 6,
    alignItems: 'center',
  },
  toggleText: {
    color: theme.gray[400],
    fontSize: 13,
  },
  toggleTextAccent: {
    color: PURPLE_LIGHT,
    fontWeight: '600',
  },
  divider: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginVertical: 14,
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: BORDER_SUBTLE,
  },
  dividerText: {
    color: theme.gray[400],
    paddingHorizontal: 14,
    fontSize: 12,
    fontWeight: '500',
    letterSpacing: 1,
  },
  socialRow: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  socialIconButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 14,
    minHeight: 48,
    borderWidth: 1,
    borderColor: BORDER,
    backgroundColor: INPUT_BG,
  },
  socialButtonPressed: {
    borderColor: PURPLE,
    backgroundColor: '#1A2035',
  },
  socialButtonHover: {
    borderColor: PURPLE_LIGHT,
    backgroundColor: '#1C2540',
  },
  googleLogoContainer: {
    width: 22,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  appleLogoContainer: {
    width: 22,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  microsoftLogoContainer: {
    width: 22,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  guestButton: {
    alignSelf: 'center',
    marginTop: 14,
    paddingVertical: 9,
    paddingHorizontal: 18,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: BORDER,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guestButtonPressed: {
    borderColor: PURPLE,
    backgroundColor: '#1A2035',
  },
  guestButtonHover: {
    borderColor: PURPLE_LIGHT,
    backgroundColor: '#1C2540',
  },
  guestButtonText: {
    color: PURPLE_LIGHT,
    fontSize: 13.5,
    fontWeight: '600',
    letterSpacing: 0.2,
  },
  marketingConsentButton: {
    marginTop: 8,
    marginBottom: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: BORDER_SUBTLE,
    backgroundColor: '#1A2132',
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  marketingConsentButtonPressed: {
    opacity: 0.88,
  },
  marketingConsentRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  marketingConsentCheckbox: {
    width: 18,
    height: 18,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#64748B',
    backgroundColor: '#111827',
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  marketingConsentCheckboxChecked: {
    backgroundColor: PURPLE,
    borderColor: PURPLE,
  },
  marketingConsentText: {
    flex: 1,
    color: theme.gray[300],
    fontSize: 12,
    lineHeight: 17,
  },
  marketingConsentCheckmark: {
    color: theme.white,
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 14,
  },
  legalConsentButton: {
    marginTop: 8,
    marginBottom: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: BORDER_SUBTLE,
    backgroundColor: '#1A2132',
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  legalConsentButtonInvalid: {
    borderColor: '#F87171',
  },
  legalConsentButtonPressed: {
    opacity: 0.88,
  },
  legalConsentRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  legalConsentTextWrap: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  legalConsentPlain: {
    color: theme.gray[300],
    fontSize: 12,
    lineHeight: 17,
  },
  legalConsentLink: {
    color: PURPLE_LIGHT,
    fontSize: 12,
    lineHeight: 17,
    fontWeight: '600',
    textDecorationLine: 'underline',
  },
  legalConsentLinkPressed: {
    opacity: 0.75,
  },
  termsErrorContainer: {
    marginBottom: 8,
  },
});

// Merged export — SignInForm imports this single object and uses s.xxx for everything
export const signInFormStyles = { ...signInStyles, ...formStyles };
